import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { AdvertisingCreateUseCaseInterface } from 'domain/usecases';

export class RemoteAdvertisingCreate
  implements AdvertisingCreateUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: AdvertisingCreateUseCaseInterface.Params,
  ): Promise<AdvertisingCreateUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url + `/${params.organizationHashId}/advertisement`,
      body: { ...params, organizationHashId: undefined },
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
